module.exports = __webpack_public_path__ + "img/pic7.f5afa383.png";